import { MetaSliceShape } from './types';

export const metaUserAgentSelector = (state: MetaSliceShape) => state.meta.userAgent;
